module.exports = __webpack_public_path__ + "static/img/logo_7.41f7af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_7.png
// module id = 1MoI
// module chunks = 1